import type { ComponentType, SVGProps } from 'react'
import type { Theme } from '@mui/material/styles'
import type {
  PaymentPresentation,
  PaymentPresentationVariant,
} from '@/domain/order/order-details-payment-presentation'
import { BanknoteIcon, CheckmarkCircleIcon, CrossIcon, InfoCircleIcon } from '@/components/icons'
import { paymentPresentationAccent } from '@/utils/order-details-ui'

type PaymentStatusIcon = ComponentType<SVGProps<SVGSVGElement>>

const PAYMENT_STATUS_VARIANT_ICON: Record<PaymentPresentationVariant, PaymentStatusIcon> = {
  success: CheckmarkCircleIcon,
  warning: BanknoteIcon,
  error: CrossIcon,
  neutral: InfoCircleIcon,
}

export type PaymentStatusIndicatorPresentation = {
  label: string
  Icon: PaymentStatusIcon
  accentColor: string
}

/** Single source of truth for payment status indicator (label, icon, accent). */
export function resolvePaymentStatusIndicatorPresentation(
  presentation: Pick<PaymentPresentation, 'statusLabel' | 'statusVariant'>,
  theme: Pick<Theme, 'palette'>
): PaymentStatusIndicatorPresentation {
  return {
    label: presentation.statusLabel,
    Icon: PAYMENT_STATUS_VARIANT_ICON[presentation.statusVariant] ?? InfoCircleIcon,
    accentColor: paymentPresentationAccent(theme, presentation.statusVariant),
  }
}
